import {Accessibility} from "../models/Accessibility";
import {AccessibilityUnit} from "../models/AccessibilityUnits";
import {PropertyAccessibilityImages} from "../models/PropertyAccessibilityImages";
import {GeneralImageThumbnails, Property} from "../models/Property";

/**
 * The general image of a property: `small` in lists, `medium` in galleries.
 * Falls back to the original image when the property has no thumbnails.
 */
export const getPropertyGeneralImage = (
  property: Pick<Property, 'general_image' | 'general_image_thumbnails'>,
  size: keyof GeneralImageThumbnails
): string => property.general_image_thumbnails?.[size] || property.general_image

export const getFilteredPropertyImagesByDisabilityType = (
  propertyImages: PropertyAccessibilityImages[],
  disabilityTypes: Array<string>,
  accessibilities: Accessibility[] | undefined
): PropertyAccessibilityImages[] => {
  let filteredPropertyImages = propertyImages
  if (disabilityTypes?.length > 0 && filteredPropertyImages?.length > 0) {
    filteredPropertyImages = filteredPropertyImages.filter((image) => {
      if (image.items) {
        if (image.items.length > 0) {
          const filteredAccessibilities = accessibilities?.filter((a) => (
            a.accessibility_unit === image.accessibility_unit
          ))
          const disabilityTypesFromAccessibilities: any = []

          image.items.forEach((i) => {
            const filteredByItem = filteredAccessibilities?.filter((acc) => i === acc.item)
            if (filteredByItem && filteredByItem.length > 0) {
              filteredByItem.forEach((filteredItem) => {
                if (filteredItem.disability_types) {
                  disabilityTypesFromAccessibilities.push(...filteredItem.disability_types)
                }
              })
            }
          })
          const uniqDisabilityTypes = [...new Set(disabilityTypesFromAccessibilities)]
          if (uniqDisabilityTypes.length > 0) {
            return disabilityTypes.some((item: string) => uniqDisabilityTypes.includes(item))
          } else {
            return true
          }
        } else {
          return true
        }
      }
      return false
    })
  }
  return filteredPropertyImages
}

export const replaceNestedAccessibilityImages = (images: PropertyAccessibilityImages[], accessibleUnits: AccessibilityUnit[]) => {
  return images?.map((image) => {
    let accessibilityUnitId = image.accessibility_unit
    let related = false
    const relatedUnit = accessibleUnits
      .find((unit) => unit.id === image.accessibility_unit)
    if (relatedUnit && relatedUnit.related_to.length > 0) {
      accessibilityUnitId = relatedUnit.related_to[0]
      related = true
    }
    return {
      ...image,
      accessibility_unit: accessibilityUnitId,
      related: related
    }
  })
}

export const sortPropertyImages = (propertyImages: PropertyAccessibilityImages[], accessibleUnits: AccessibilityUnit[]) => {
  const sortedPropertyImages: PropertyAccessibilityImages[] = []
  const sortedAccessibleUnits = accessibleUnits
    .sort((a,b) => a.order - b.order)
  sortedAccessibleUnits.forEach((unit) => {
    const filteredImages = propertyImages
      .filter((i) => i.accessibility_unit === unit.id)
    if (filteredImages.length > 0) {
      sortedPropertyImages.push(...filteredImages)
    }
  })
  return sortedPropertyImages
}
